import { Icon, Input } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { MAX_SEARCH_LENGTH } from '@hero/constants';
import { useDebounceEffect } from '@hero/hooks';

function SearchInput({ value = '', onChange, placeholder = 'Search', size = 'sm' }) {
  const [searchTerm, setSearchTerm] = useState(value);

  useDebounceEffect(() => onChange(searchTerm), 500, [searchTerm]);

  const handleChange = e => {
    setSearchTerm(e.target.value);
  };

  const onReset = () => {
    setSearchTerm('');
  };

  return (
    <Input
      value={searchTerm}
      placeholder={placeholder}
      onChange={handleChange}
      size={size}
      inputProps={{
        maxLength: MAX_SEARCH_LENGTH
      }}
      endIcon={
        searchTerm ? (
          <Icon color="var(--color-components-input-fg-default)" name="close" onClick={onReset} />
        ) : (
          <Icon color="var(--color-components-input-fg-default)" name="search" />
        )
      }
      helperProps={{
        counter: undefined
      }}
    />
  );
}

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  size: PropTypes.string
};

export { SearchInput };
